export var standingsFilterOpenKey = 'isStandingsFilterOpen';
